import {
  Box,
  Button,
  Drawer,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { useEffect, useState, useCallback } from 'react';
import '../pharmaReports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { useTranslation } from 'react-i18next';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';

const DrugUtilization = () => {
  const { t } = useTranslation();
  const [DrugUtilizationData, setDrugUtilizationData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);

  const [isLoader, setIsLoader] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [isErrorMsgText, setIsErrorMsgText] = useState('');
  const [successMsg, setSuccessMsg] = useState(false);
  const [successMsgText, setSuccessMsgText] = useState('');

  const errorMessage = (message) => {
    setIsErrorMsg(true);
    setIsErrorMsgText(message);
    setDisableBtn(false);
    setDisabled(false);
  };

  const msgClose = () => {
    setIsErrorMsg(false);
    setIsErrorMsgText('');
    setSuccessMsg(false);
    setSuccessMsgText('');
  };

  const gridToolBar = () => {
    const toDate = DateTime.now().toFormat('yyyy-MM-dd');
    const fromDate = DateTime.now().minus({ months: 2 }).startOf('month').toFormat('yyyy-MM-dd');
    let TextArray = [
      { label: "From Date", value: formatDate(fromDate) },
      { label: "To Date", value: formatDate(toDate) },
      ]
    return (
      <Box>
          <CommonGridToolBarWithFilterText FilterTextArray={TextArray}
           />
      </Box>
      )
  }

  const getDrugUtilizationData = useCallback(() => {
    try {
      setIsLoader(true)
      const pharmacyId = JSON.parse(localGetItem('loggedInUserInfo'))?.pharmacy_id
      RestAPIService.getAll(Serviceurls.PHARMA_THREE_MONTH_REPORT_GET + `?pharmacy_id=${pharmacyId}`)
        .then((res) => {
          if (res?.data?.status === 'success') {
            const rows = res?.data?.data?.result?.map((item, index) => ({
              ...item,
              sno: index + 1,
            }));
            setDrugUtilizationData(rows);
            setRowCount(res?.data?.data?.total_count);
          }
          setIsLoader(false);
        })
        .catch((err) => {
          setIsLoader(false);
          setDrugUtilizationData([]);
          setRowCount(0);
          errorMessage(err?.response?.data?.message || err.message);
        });
    } catch (error) {
      setIsLoader(false);
      errorMessage(error.message);
    }
  }, []);

//   const renderFilter = (data) => {
//     setFilterDatas(data);
//     setFilterOpen(false);
//     setPage(0);
//     getDrugUtilizationData(data, 0, pageSize);
//   };

//   const clearFilter = (data) => {
//     setFilterDatas(data);
//   };
 const getDrugUtilizationExcel = () => {
    try {
      setDisableBtn(true);
       const pharmacyId = JSON.parse(localGetItem('loggedInUserInfo'))?.pharmacy_id
      RestAPIService.excelGet(Serviceurls.PHARMA_THREE_MONTH_REPORT_GET + `?pharmacy_id=${pharmacyId}`+ `&export_type=excel`)
        .then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"].split("filename=")[1]

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            setDisableBtn(false);

          }
        }).catch((error) => {
          if (error?.response?.data?.status === "fail") {
            errorMessage(error.response.data.message)
          } else {
            errorMessage(error.message)
          }
          setDisableBtn(false);
        })
    } catch (e) {
      errorMessage(e?.message)
      setDisableBtn(false);
    }
  }

  useEffect(() => {
    getDrugUtilizationData();
  }, []);

  const columns = [
    {
      field: 'sno', headerName: 'S.No', flex: 0.7, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>
        {row?.sno ?? "-"}</Box>)
    },
    {
      field: 'drug_ms__drug_name', headerName: 'Drug Name', flex: 1.5, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>{row?.drug_ms__drug_name?.length > 25 ?
        <Tooltip placement='top' title={row?.drug_ms__drug_name} arrow><div>{row?.drug_ms__drug_name?.slice(0, 23) + "..."}</div></Tooltip>
        : row?.drug_ms__drug_name ? row?.drug_ms__drug_name : "-"}</Box>)
    },
    {
      field: 'vendor_name', headerName: 'Last Vendor Name', flex: 1.5, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>{row?.vendor_name?.length > 25 ?
        <Tooltip placement='top' title={row?.vendor_name} arrow><div>{row?.vendor_name?.slice(0, 23) + "..."}</div></Tooltip>
        : row?.vendor_name ? row?.vendor_name : "-"}</Box>)
    },
    {
      field: 'before_prev_qty', headerName: 'Before Previous Month', flex: 1, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>
        {row?.before_prev_qty ?? "-"}</Box>)
    },
    {
      field: 'prev_month_qty', headerName: 'Previous Month', flex: 1, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>
        {row?.prev_month_qty ?? "-"}</Box>)
    },
    {
      field: 'current_month_qty', headerName: 'Current Month', flex: 1, sortable: true,
      renderCell: ({ row }) => (
      <Box component={'div'}>
      {row?.current_month_qty ?? "-"}</Box>)
    },
    {
      field: 'available_qty', headerName: 'Available Quantity', flex: 1, sortable: true,
      renderCell: ({ row }) => (<Box component={'div'}>
        {row?.available_qty ?? "-"}</Box>)
    },
  ];
  

  return (
    <Box component={'div'} className='eMed_rts_container'>

      <Box component={"div"} className='eMed_Top_Container'>
        <Box component={"div"} className='eMed_Cards_Container'>
          {/* {AmountsCard(t("Total Bill Amount"), this.state.total_bill_amount)}
          {AmountsCard(t("Total Discount"), this.state.total_concession)} */}

        </Box>

        <Box component={"div"} className='eMed_Action_Container'>
          <Box component={"div"} className='eMed_Filter_Icon_div'>
            <Button  className='eMed_usrconf_btn' disabled={disableBtn} onClick={getDrugUtilizationExcel}>
              <img src={ImagePaths.ExportIcon.default} alt="export" className='eMed_action_img' />
            </Button>
          </Box>

        </Box>
      </Box>
      <Box component={'div'} className='eMed_rts_table'>
        <DataGrid
          rows={DrugUtilizationData}
          columns={columns}
          getRowId={(row) => row.sno}
          page={page}
          pageSize={pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Stack className='eMed_conf_nodata'>
                {t("NoRecordsFound")}
              </Stack>
            )
          }}
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newSize) => {
            setPageSize(newSize);
          }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={isLoader}
        />
      </Box>

      {isErrorMsg && (
        <ToastMsg severity="error" msg={isErrorMsgText} msgPop={msgClose} />
      )}
      {successMsg && (
        <ToastMsg severity="success" msg={successMsgText} msgPop={msgClose} />
      )}
    </Box>
  )
}

export default DrugUtilization;
